import './ItemsCounter.css';

import React from 'react';
import { hasItems } from '../types/pageState';

const ItemsCounter = ({ pageState, processMenuItems }) => {
  if (!hasItems(pageState)) {
    return null;
  }

  const items = pageState.items || [];
  const totalItems = items.filter(item => !item.loading).length;
  const filteredItems = processMenuItems(items, false).filter(item => !item.loading).length;

  return <p className="items-count-text">{`${filteredItems} of ${totalItems} items`}</p>;
};

export default ItemsCounter;
